module.exports = __webpack_public_path__ + "static/media/Loneliness.09305785.png";